"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachHotelCard = attachHotelCard;
exports.createMarkers = createMarkers;
exports.createRegionMarker = createRegionMarker;
exports.default = MapViewDLPVariant;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _jsApiLoader = require("@googlemaps/js-api-loader");
var _api = require("@whitbread-eos/api");
var _utils = require("@whitbread-eos/utils");
var _config = _interopRequireDefault(require("next/config"));
var _react2 = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _initializeMap = _interopRequireDefault(require("../../utils/initializeMap"));
var _MapHotelCard = _interopRequireDefault(require("../MapHotelCard"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function MapViewDLPVariant(_ref) {
  var {
    items,
    icons,
    baseDataTestId,
    latitude,
    longitude
  } = _ref;
  var {
    publicRuntimeConfig = {}
  } = (0, _config.default)() || {};
  var hotelMapRef = (0, _react2.useRef)(null);
  var hotelOverlayRef = (0, _react2.useRef)(null);
  var [displayedItem, setDisplayedItem] = (0, _react2.useState)(null);
  (0, _react2.useEffect)(() => {
    var loader = new _jsApiLoader.Loader({
      apiKey: publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: []
    });
    loader.load().then(() => {
      if (hotelMapRef !== null && hotelMapRef !== void 0 && hotelMapRef.current) {
        var hotelMap = (0, _initializeMap.default)(latitude, longitude, hotelMapRef, publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_MAP_ID_DLP);
        displayMarkers(hotelMap, items, icons, latitude, longitude, hotelOverlayRef, setDisplayedItem);
      }
    });
  }, [items, baseDataTestId, latitude, longitude, icons, publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [hotelOverlayRef.current && displayedItem && _reactDom.default.createPortal((0, _jsxRuntime.jsx)(_MapHotelCard.default, {
      data: displayedItem
    }), hotelOverlayRef.current), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread({
      "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'mapView'),
      ref: hotelMapRef
    }, mapContainerStyles))]
  });
}
function createMarkers(_x, _x2, _x3, _x4, _x5) {
  return _createMarkers.apply(this, arguments);
}
function _createMarkers() {
  _createMarkers = (0, _asyncToGenerator2.default)(function* (items, hotelMap, icons, hotelOverlayRef, setDisplayedItem) {
    var {
      AdvancedMarkerElement
    } = yield google.maps.importLibrary('marker');
    var selected = document.createElement('img');
    selected.src = (0, _utils.formatAssetsUrl)(icons['icon.pin-selected']);
    var markers = items.map(item => {
      var _item$coordinates$lat, _item$coordinates, _item$coordinates$lon, _item$coordinates2, _item$distanceFromRef;
      var pin = document.createElement('img');
      switch (item.brand) {
        case _api.HotelBrand.ZIP:
          pin.src = (0, _utils.formatAssetsUrl)(icons['icon.pin-zip']);
          break;
        case _api.HotelBrand.HUB:
          pin.src = (0, _utils.formatAssetsUrl)(icons['icon.pin-hub']);
          break;
        default:
          pin.src = (0, _utils.formatAssetsUrl)(icons['icon.pin-default']);
          break;
      }
      var marker = new AdvancedMarkerElement({
        position: {
          lat: (_item$coordinates$lat = (_item$coordinates = item.coordinates) === null || _item$coordinates === void 0 ? void 0 : _item$coordinates.latitude) !== null && _item$coordinates$lat !== void 0 ? _item$coordinates$lat : 0,
          lng: (_item$coordinates$lon = (_item$coordinates2 = item.coordinates) === null || _item$coordinates2 === void 0 ? void 0 : _item$coordinates2.longitude) !== null && _item$coordinates$lon !== void 0 ? _item$coordinates$lon : 0
        },
        map: hotelMap,
        content: pin
      });
      marker.selectedContent = selected;
      marker.defaultContent = pin;
      marker.hotelBrandLabel = item.brand;
      marker.hotelDistanceFromSearch = ((_item$distanceFromRef = item.distanceFromReference) !== null && _item$distanceFromRef !== void 0 ? _item$distanceFromRef : 0).toFixed(2);
      attachHotelCard({
        marker,
        hotelMap,
        hotelOverlayRef,
        setDisplayedItem,
        item
      });
      return marker;
    });
    markers.forEach(marker => marker.addListener('click', () => {
      markers.forEach(marker => marker.content = marker.defaultContent);
      marker.content = marker.selectedContent;
      _utils.analytics.update({
        dlp: _objectSpread(_objectSpread({}, window.analyticsData.dlp), {}, {
          hotelBrandLabel: marker.hotelBrandLabel,
          hotelDistanceFromSearch: marker.hotelDistanceFromSearch
        })
      });
    }));
    return markers;
  });
  return _createMarkers.apply(this, arguments);
}
function createRegionMarker(_x6, _x7, _x8, _x9) {
  return _createRegionMarker.apply(this, arguments);
}
function _createRegionMarker() {
  _createRegionMarker = (0, _asyncToGenerator2.default)(function* (latitude, longitude, hotelMap, icons) {
    var {
      AdvancedMarkerElement
    } = yield google.maps.importLibrary('marker');
    var pin = document.createElement('img');
    pin.src = (0, _utils.formatAssetsUrl)(icons['icon.pin-city']);
    return new AdvancedMarkerElement({
      position: {
        lat: latitude !== null && latitude !== void 0 ? latitude : 0,
        lng: longitude !== null && longitude !== void 0 ? longitude : 0
      },
      map: hotelMap,
      content: pin
    });
  });
  return _createRegionMarker.apply(this, arguments);
}
function getMapBounds(markers) {
  var bounds = new google.maps.LatLngBounds();
  markers.forEach(marker => {
    var markerPosition = marker.position;
    bounds.extend(markerPosition);
  });
  return bounds;
}
function displayMarkers(_x10, _x11, _x12, _x13, _x14, _x15, _x16) {
  return _displayMarkers.apply(this, arguments);
}
function _displayMarkers() {
  _displayMarkers = (0, _asyncToGenerator2.default)(function* (hotelMap, hotels, icons, latitude, longitude, hotelOverlayRef, setDisplayedItem) {
    var markers = [...(yield createMarkers(hotels, hotelMap, icons, hotelOverlayRef, setDisplayedItem)), yield createRegionMarker(latitude, longitude, hotelMap, icons)];
    var bounds = getMapBounds(markers);
    hotelMap.fitBounds(bounds);
  });
  return _displayMarkers.apply(this, arguments);
}
var infoWindow;
function attachHotelCard(_ref2) {
  var {
    marker,
    hotelMap,
    hotelOverlayRef,
    setDisplayedItem,
    item
  } = _ref2;
  var stringyfiedContent = "<div id=\"hotel-overlay\"></div>";
  infoWindow = new google.maps.InfoWindow({
    content: stringyfiedContent
  });
  marker.addListener('click', (0, _asyncToGenerator2.default)(function* () {
    infoWindow.open({
      map: hotelMap,
      anchor: marker
    });
    yield (0, _utils.waitForElement)('#hotel-overlay');
    var el = document.getElementById('hotel-overlay');
    if (el) {
      hotelOverlayRef.current = el;
      setDisplayedItem(item);
      infoWindow.addListener('closeclick', () => {
        infoWindow.close();
      });
      google.maps.event.addListener(hotelMap, 'click', () => {
        infoWindow.close();
      });
      google.maps.event.addListener(hotelMap, 'drag', () => {
        infoWindow.close();
      });
    }
  }));
}
var mapContainerStyles = {
  height: '100%'
};